import {
    Component,
    OnInit,
    AfterViewInit, OnDestroy,
    Input,
    ViewChild,
    Renderer2,
    HostListener, ElementRef
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {SlickGridComponent} from 'app/slick-grid/slick-grid.component';
import {StocksService} from 'app/stocks/services/stocks.service';
import {CommonDataService} from 'app/services/common-data.service';
import {StocksFilterService} from "app/stocks/services/stocks-filter.service";
import {ISubscription} from "rxjs/Subscription";
import {ValidateData} from 'app/stocks/models/validate-data';
import {StocksHelper} from "../../models/stocks-helper";
import {FilterType} from "../../models/filter-type";
import {StocksFilter} from "../../models/stocks-filter";
import {Observable} from "rxjs/Observable";
import {CodeName} from "../../models/code-name";
import Popper from "popper.js";
import Timer = NodeJS.Timer;
import {Renderer2Interceptor} from "@angular/core/src/render/api";

@Component({
    selector: 'not-validated-data',
    templateUrl: './not-validated-data.component.html',
    styleUrls: ['./not-validated-data.component.css']
})
export class NotValidatedDataComponent implements OnInit, AfterViewInit, OnDestroy{

    constructor(public readonly translateService: TranslateService,
                private readonly renderer: Renderer2,
                private readonly stocksService: StocksService,
                public readonly commonData: CommonDataService,
                private filterService: StocksFilterService){

        // this.ordersSelectionModel = new Slick.RowSelectionModel<ValidateData, Slick.Range[]>({selectActiveRow: false});
        this.gridView = new Slick.Data.DataView<ValidateData>();

        this.options = {
            syncColumnCellResize: false,
            multiColumnSort: false,
            editable: false,
            autoEdit: false,
        };

        this.develop = false;
        this._showGrid = false;
        this.gridHeight = 121;
        this.gridUp = false;
        this.slickScrollWidth = 12;
        this.helper = new StocksHelper();
    }

    // @HostBinding('class.show') get initialized() { return this.init; }

    @Input() data: ValidateData[];
    @Input() type: number;
    @Input() param: string;
    @Input() GUID: string;
    @Input() getDataFunc: (param: string, filter: StocksFilter) => Observable<CodeName[]>;
    @Input() excludeResWarn?: boolean;
    @Input() inWrpClasses?: string[];

    @ViewChild('grid')
    private grid: SlickGridComponent;

    @ViewChild('gridWrpEl')
    private gridWrpEl: ElementRef;

    @ViewChild('mainWrapper')
    private mainWrapper: ElementRef;

    @ViewChild('popper')
    private popper: ElementRef;

    @ViewChild('img')
    private img: ElementRef;

    public readonly gridView: Slick.Data.DataView<ValidateData>;
    public columns: Slick.Column<ValidateData>[];
    public readonly options: Slick.GridOptions<ValidateData>;
    // private readonly ordersSelectionModel: Slick.RowSelectionModel<{data: string}, Slick.Range[]>;
    private develop: boolean;
    public wrpClass: any;
    private subscriptionData: ISubscription;
    private subscriptionHideGrid: ISubscription;
    private subscriptionScroll: ISubscription;
    public _showGrid: boolean;
    public gridHeight: number;
    public gridUp: boolean;
    public $filter: any;
    private readonly slickScrollWidth: number;
    private helper: StocksHelper;
    public loading: boolean;
    public msgBottom: boolean;
    public outerWrp: Element;
    public interval: Timer;
    private listenerIn: () => void;
    private listenerOut: () => void;

    @HostListener('window:mousedown', ['$event']) onMouseDown(e: MouseEvent){
        this.hideGridOnClick(e);
    }

    ngOnInit(){

        this.setColumns();

        //# this subscription update list of excluded items
        this.subscriptionData = this.filterService.updateValidateDataCurrent.subscribe((res: {GUID: string, param: string, data: ValidateData[]}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.updateData = res: null)
        );

        //# hides opened list if we open other list, on filter form
        this.subscriptionHideGrid = this.filterService.hideFilterGridCurrent.subscribe((res: {GUID: string, param: string}) =>
            this.helper.tryCatch(() => res && res.GUID === this.GUID ? this.hideGrid = res.param : null)
        );

        //# updates position of list with items, when we change position of filter by scrolling
        this.subscriptionScroll = this.filterService.filtersScrollCurrent.subscribe(res => this.helper.tryCatch(() => this.scrollPosition = res));


    }

    ngOnDestroy(){
        this.subscriptionHideGrid.unsubscribe();
        this.subscriptionData.unsubscribe();
        this.subscriptionScroll.unsubscribe();
        clearInterval(this.interval);
        this.interval = null;
    }

    ngAfterViewInit(){
        this.helper.wait(() => {
            this.fillDataForGrid();
            this.calculateHeightForGrid();
            this.$filter = $(this.getFilterElement());
            this.grid.resizeGrid();
            //this.popperObj = this.helper.popperAdd(this.img, this.popper, document.body, 'auto', ['bottom', 'top'], false)
            if (this.inWrpClasses && this.inWrpClasses.length > 1){
                let elements = document.getElementsByClassName(this.inWrpClasses[0]);
                if (elements && elements.length){
                    this.outerWrp = elements[0];
                }
            }
            this.listenerIn = this.renderer.listen(this.img.nativeElement, 'mouseover', e => this.zIndexForWrp(true));
            this.listenerOut = this.renderer.listen(this.img.nativeElement, 'mouseout', e => this.zIndexForWrp(false));
            this.tooltipPosition();
            this.interval = setInterval(this.tooltipPosition, 2000)
        },150);
    }

    private readonly tooltipPosition = (): void => {
        if (this.outerWrp){
            let diff = this.excludeResWarn ? 45 : 25;
            this.msgBottom = this.mainWrapper.nativeElement.getBoundingClientRect().top - this.outerWrp.getBoundingClientRect().top < diff;
        }
    }

    /**
     * initialise columns for grid
     */
    private setColumns = (): void => {
        this.columns = [
            {id: 'code', field: 'code', name: '', sortable: true, width: 288}
        ]

        if (this.type === FilterType.CodeName){
            this.columns[0].width = 100;
            this.columns.push({id: 'name', field: 'name', name: '', sortable: true, width: 188})
        }
    }

    //# prepare and set data to grid
    private fillDataForGrid = (): void => {
        this.data.forEach((item, index) => item.id = index + 1);
        this.gridView.setItems([]);
        this.gridView.setItems(this.data);
    };

    //# hide grid whet we open other list
    public set hideGrid(param: string){
        if (this.param + 'validate' !== param){
            this.showGrid = false;
        }
    }

    //# show grid and send signal for hide other lists
    public set showGrid(value: boolean){
        if (this._showGrid !== value){
            this._showGrid = value;
            if (value) {
                this.filterService.setHideFilterGrid({ GUID: this.GUID, param: this.param + 'validate'});
                this.zIndexForWrp(true);
            } else{
                this.zIndexForWrp(false);
            }
        }
    }

    public get showGrid(){
        return this._showGrid;
    }

    //# update data in grid when something in filter changes
    set updateData(validateObj: {param: string, data: ValidateData[]}){
        if (validateObj && validateObj.param) {
            if (validateObj.param === this.param) {
                this.data = validateObj.data;
                this.fillDataForGrid();
                this.calculateHeightForGrid();
                let timeout = setTimeout(() => {
                    clearTimeout(timeout);
                    timeout = null;

                    this.grid.resizeGrid();
                },100);
            }
        }
    }

    //# change position of grid when scroll position changes
    private set scrollPosition(value: number){
        if (value !== null){
            this.setGridTop();
            this.columnWidth();
        }
    };

    //# generate class for mainWrp, based on filter type
    /*private generateWrpClass = (): any =>{
        let classes: any = {wrp: true};
        switch (this.type){
            case 1:
                classes['type-1'] = true;
                break;
            case 2:
                classes['type-2'] = true;
                break;
            case 3:
                classes['type-3'] = true;
                break;
            case 4:
                classes['type-4'] = true;
                break;
            case 5:
                classes['type-5'] = true;
                break;
        }
        return classes;
    };*/

    //# toggle show grid on component click
    public showGridOnClick = (): void => {
        this.showGrid = !this.showGrid;
        if (this.showGrid){

            this.setGridTop();
            this.columnWidth();
            if (this.type === FilterType.CodeName){
                this.loading = true;
                let filter = new StocksFilter();
                filter[this.param] = this.data.map(d => d.code);

                this.getDataFunc(this.param, filter).subscribe(res => {
                    if  (res && res.length){
                        let resObj = this.helper.arrToObj(res, 'code');
                        this.data.forEach(d =>{
                            if (resObj[d.code]){
                                d.name = resObj[d.code].name;
                            }
                        })
                    }
                    this.grid.invalidate();
                    this.loading = false
                })
            }

            // this.helper.wait(() => this.loading = false, 1500)
        }

            /*if (this.showGrid) {
                this.filterService.setHideGridSelectedFilter(false);
            }*/
    };

    //# calculate height for grid, based on quantity of rows
    private calculateHeightForGrid = (): void =>{
        this.gridHeight = 0;
        /*if (this.data.length === 1) {
            this.gridHeight += 25 * this.data.length;
        } else*/ if (this.data.length < 5) {
            this.gridHeight += 25 * this.data.length;
        } else {
            this.gridHeight = 125;
        }
    };

    //# define where should be grid, on top or bottom of component
    private setGridTop = (): void => {
        if (this.showGrid) {
            let $modalBody = $('.modal-body'),
                modalBodyH = $modalBody.outerHeight(),
                $gridWrp = $(this.gridWrpEl.nativeElement);

            this.gridUp = modalBodyH - this.$filter.position().top - this.$filter.outerHeight() < $gridWrp.outerHeight();


            /*if (up) {
                this.gridTop = $mainWrapper.position().top - $gridWrp.outerHeight();
            } else {
                this.gridTop = $mainWrapper.position().top + $mainWrapper.outerHeight();
            }*/
        } else {
            //this.gridTop = -1000;
        }
    };

    //# get filter element
    private getFilterElement = (): Element => {
        let el = this.mainWrapper.nativeElement;

        while (el){

            if (el.tagName.toLowerCase() === 'filter-search-code-name') {
                break;
            }
            el = el.parentElement;
        }

        return el;
    };

    //# set grid column width
    private columnWidth = (): void => {
        let width = this.gridWrpEl.nativeElement.offsetWidth - 2;

        if (this.data.length > 5) {
            width = width - this.slickScrollWidth;
        }

        if (this.columns.length === 1) {
            this.columns.forEach(item => {
                if (item.field === 'code'){
                    item.width = width;
                }
            });
        } else {
            let lastWidth:  number = 0;
            this.columns.forEach((item, i) => {
                if (this.columns.length === i + 1){
                    item.width = width - lastWidth;
                }
                lastWidth += item.width;
            });
        }


        this.grid.resizeGrid();
    };

    //# hide grid when we click out of the component
    private hideGridOnClick = (e: MouseEvent): void =>{

        if (this.showGrid && e.target){
            let parentElement = e.target,
                hideGrid: boolean = true;
            while (parentElement){
                if (this.mainWrapper && this.mainWrapper.nativeElement.isSameNode(parentElement)) hideGrid = false;
                if (!hideGrid) break;
                parentElement = this.renderer.parentNode(parentElement);
            }

            if (hideGrid){
                this.showGrid = false;
            }
        }
    };

    //# add more z-index for current filter
    private zIndexForWrp = (add: boolean): void => {
        let parentElement = this.mainWrapper.nativeElement;
        const hasClass = (element: Element): boolean => {
            let classes = element.classList, rowEl;
            for (let i =  0; i < classes.length; i++ ) {
                if (classes[i] === 'filter-wrp'){
                    rowEl = true;
                }
            }
            return rowEl;
        };

        while (parentElement){
            if (hasClass(parentElement)) {
                break;
            }
            parentElement = parentElement.parentElement;
        }
        add ? parentElement.classList.add('z-index-top') : parentElement.classList.remove('z-index-top');
    }
}




// WEBPACK FOOTER //
// ./src/app/stocks/components/not-validated-data.component/not-validated-data.component.ts